var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Oops!")]),_c('h3',[_vm._v(" The "),(_vm.resource)?[_vm._v(" "+_vm._s(_vm.resource)+" ")]:_vm._e(),_vm._v(" page you're looking for is not here. ")],2),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Back to the home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }